// extracted by mini-css-extract-plugin
export default {"page":"pageShell_page__YMaq-"};